// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"uploaded-file-card_wrapper__TR_j5","title":"uploaded-file-card_title__FA_9G","delete":"uploaded-file-card_delete__Lpoql"};